import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { WorkId } from 'js/liswp/types';

type WorksPercentilesResponse = {
  percentiles: Record<string, string>; // work ID -> percentile text
};

export const getWorksPercentiles = async (
  workIds: Array<WorkId>,
): Promise<WorksPercentilesResponse> => {
  const response = await fetchWithCsrf(
    routes.api_v0_works_percentiles_path({
      work_ids: workIds,
      subdomain_param: 'api',
    }),
    { method: 'GET' },
  );

  if (!response.ok) {
    throw new Error('Failed to load work percentiles');
  }

  return (await response.json()) as WorksPercentilesResponse;
};

type WorksViewsResponse = {
  views: Record<string, number>; // work ID -> view count
};

export const getWorksViews = async (
  workIds: Array<WorkId>,
): Promise<WorksViewsResponse> => {
  const response = await fetchWithCsrf(
    routes.api_v0_works_views_path({
      work_ids: workIds,
      subdomain_param: 'api',
    }),
    { method: 'GET' },
  );

  if (!response.ok) {
    throw new Error('Failed to load work views');
  }

  return (await response.json()) as WorksViewsResponse;
};

type WorkDownloadCountResponse = {
  count: number;
};

// Per-work download total from Analytics::Download. The endpoint runs a live
// COUNT with a 1s timeout and returns 504 if it can't finish, so callers should
// treat a rejection as "no count to show".
export const getWorkDownloadCount = async (
  workId: WorkId,
): Promise<WorkDownloadCountResponse> => {
  const response = await fetchWithCsrf(
    routes.api_v0_work_download_count_path({
      work_id: workId,
      subdomain_param: 'api',
    }),
    { method: 'GET' },
  );

  if (!response.ok) {
    throw new Error('Failed to load work download count');
  }

  return (await response.json()) as WorkDownloadCountResponse;
};
